/* eslint-disable */
// Manicou Runner — moteur porté depuis manicou-runner-yum.html (canvas, physique inchangée).
// Découplé du DOM : expose start(canvas, opts) et communique via callbacks.
//   opts = {
//     difficulty: 'facile'|'normal'|'difficile'|'extreme',
//     commune?: string,               // nom affiché sur le panneau
//     ads?: [ { placement, campaign, yum_protected } ],  // /api/ads/active slots
//     onScore?: ({score, collected, cupN, cupGoal}) => void,   // chaque frame
//     onThreshold?: () => void,       // (réservé, appelé par la page selon les points)
//     onDie?: ({score, collected, duration_s, impressions}) => void,
//   }
// Retour : { stop(), toggleMute() }.
import { IMG_ASSETS, LOGO_SRC } from "./assets";

export function start(canvas, opts) {
  opts = opts || {};
  var LW=900,LH=506,GROUND_Y=448,G=2650,JUMP_V=-905; // monde 16/9 (900x506), sol ancré bas
  var STATE={START:0,RUN:1,DEAD:2};
  var cv=canvas, ctx=cv.getContext('2d');
  // Assets peints injectés en data-URI (portés dans ./assets).
  var IMG={};(function(){for(var k in IMG_ASSETS){var im=new Image();im.src=IMG_ASSETS[k];IMG[k]=im;}})();
  function imgOK(im){return !!(im&&im.complete&&im.naturalWidth>0);}
  var FOODS=['taco','bubble','burger','gaufre','crepe']; // 'taco' = french tacos
  var OBSTACLES=[{key:'obs_coco',h:48},{key:'obs_barrel',h:64},{key:'obs_crab',h:42}];
  var BG_PAR=0.5;      // parallax du décor peint
  var CUP_GOAL=8;      // gourmandises pour remplir le gobelet
  var DEFAULT_COMMUNE="Le François";
  var ROUTE=[
    {name:'Champ de canne', tip:'La plaine de canne & la Montagne Pelée', bg:'bg_canne',    sky:['#a6ddff','#cfeeff','#eaf7d8'], ground:'#7a5a34'},
    {name:'Le Diamant',     tip:'Le Rocher & les cocotiers',             bg:'bg_diamant',  sky:['#bfe0ff','#ffe6c0','#ffe8c8'], ground:'#d8c08a'},
    {name:'Le bourg',       tip:'Cases créoles & marché',               bg:'bg_bourg',    sky:['#ffe3b0','#ffcf9a','#ffe9c8'], ground:'#8a6a44'},
    {name:'La mangrove',    tip:'Palétuviers au crépuscule',            bg:'bg_mangrove', sky:['#3a2a55','#7a4a5a','#d98a5a'], ground:'#5a3a28'},
    {name:'Le François',    tip:'Fonds blancs, îlets & Habitation Clément', bg:'bg_francois', sky:['#ffd9a0','#9fe0e8','#d8f4ee'], ground:'#c9b48f'}
  ];

  // ---- Réglages de difficulté (gameplay). item_value/seuil = côté serveur. ----
  var DIFF={
    facile:   {speed0:320, speedMax:720,  accel:0.013, spawnMul:1.25, foodMul:0.85, airThresh:200},
    normal:   {speed0:380, speedMax:900,  accel:0.016, spawnMul:1.00, foodMul:1.00, airThresh:120},
    difficile:{speed0:440, speedMax:980,  accel:0.019, spawnMul:0.82, foodMul:1.15, airThresh:90},
    extreme:  {speed0:520, speedMax:1080, accel:0.023, spawnMul:0.68, foodMul:1.30, airThresh:60}
  };
  var D=DIFF[opts.difficulty]||DIFF.normal;

  // ---- Logo Yüm (emplacements protégés) ----
  var logoImg=new Image(),logoReady=false;logoImg.onload=function(){logoReady=true;};logoImg.src=LOGO_SRC;

  // ---- Pub dans le décor : premier emplacement NON protégé avec une campagne ----
  // (les emplacements yum_protected gardent le logo Yüm, jamais de pub externe).
  var adSlot=null;
  if(Array.isArray(opts.ads)){
    for(var ai=0;ai<opts.ads.length;ai++){var s=opts.ads[ai];
      if(s&&!s.yum_protected&&s.campaign&&s.campaign.media_url){adSlot=s;break;}}
  }
  var adBillboard=new Image(),adBillboardReady=false;
  if(adSlot){adBillboard.onload=function(){adBillboardReady=true;};
    try{adBillboard.crossOrigin="anonymous";}catch(e){}
    adBillboard.src=adSlot.campaign.media_url;}

var audioCtx=null,muted=false;
function beep(f,d,type,vol){if(muted)return;try{if(!audioCtx)audioCtx=new (window.AudioContext||window.webkitAudioContext)();
  var o=audioCtx.createOscillator(),g=audioCtx.createGain();o.type=type||'square';o.frequency.value=f;g.gain.value=vol||.04;
  o.connect(g);g.connect(audioCtx.destination);o.start();g.gain.exponentialRampToValueAtTime(0.0001,audioCtx.currentTime+d);o.stop(audioCtx.currentTime+d);}catch(e){}}

function resize(){var dpr=Math.min(window.devicePixelRatio||1,2);
  var w=cv.clientWidth||cv.getBoundingClientRect().width||600;var h=cv.clientHeight||Math.round(w*LH/LW)||213;
  cv.width=Math.max(1,Math.round(w*dpr));cv.height=Math.max(1,Math.round(h*dpr));}

function clamp(v,a,b){return Math.max(a,Math.min(b,v));}
function lerp(a,b,t){return a+(b-a)*t;}
function parse(c){if(c.charAt(0)==='#'){var h=c.slice(1);return[parseInt(h.slice(0,2),16),parseInt(h.slice(2,4),16),parseInt(h.slice(4,6),16)];}var m=c.match(/[\d.]+/g);return[+m[0],+m[1],+m[2]];}
function mix(a,b,t){t=clamp(t,0,1);var pa=parse(a),pb=parse(b);return 'rgb('+Math.round(lerp(pa[0],pb[0],t))+','+Math.round(lerp(pa[1],pb[1],t))+','+Math.round(lerp(pa[2],pb[2],t))+')';}

// ---------- clouds + fireflies (ambient, created once) ----------
var clouds=[],flies=[];
function initAmbient(){clouds=[];for(var i=0;i<4;i++)clouds.push({x:Math.random()*LW,y:30+Math.random()*70,s:.7+Math.random()*.8,sp:6+Math.random()*8});
  flies=[];for(var j=0;j<14;j++)flies.push({x:Math.random()*LW,y:120+Math.random()*120,ph:Math.random()*6.28,sp:.4+Math.random()*.6});}

function newGame(){var si=0;/* tour complet Fort-de-France -> Le François */
  return{state:STATE.RUN,dist:0,speed:D.speed0,score:0,
  startIdx:si,communeIdx:si,
  sign:{x:LW+140,done:false},signName:ROUTE[si].name,
  toastText:ROUTE[si].name+' — '+ROUTE[si].tip,toastT:3,
  m:{x:120,y:GROUND_Y,vy:0,onGround:true,ducking:false,w:64,h:52,runFrame:0,deadT:0,rot:0},
  obs:[],parts:[],spawnIn:52,night:0,dustT:0,
  food:[],foodIn:80,collected:0,bonus:0,cupN:0,cupFull:0,bgPrev:null,bgFade:1};}
// ---------- gourmandises YUM à ramasser ----------
function spawnFood(g){var key=FOODS[(Math.random()*FOODS.length)|0];var air=Math.random()<0.5;
  g.food.push({type:'food',key:key,x:LW+40,y:air?GROUND_Y-92:GROUND_Y-22,w:42,h:42,bob:Math.random()*6,got:false});}
function collectFood(g,fd){g.collected++;g.bonus+=5;g.cupN++;
  for(var i=0;i<8;i++)g.parts.push({x:fd.x,y:fd.y,vx:(Math.random()-.5)*180,vy:-Math.random()*180,life:.5,r:2+Math.random()*2,c:'#ffde59'});
  beep(880,.06,'sine',.04);
  if(g.cupN>=CUP_GOAL){g.cupN=0;g.bonus+=20;g.cupFull++;beep(1200,.14,'sine',.05);
    for(var j=0;j<16;j++)g.parts.push({x:g.m.x+30,y:g.m.y-24,vx:(Math.random()-.5)*260,vy:-Math.random()*240,life:.7,r:2+Math.random()*3,c:['#ff2e18','#ffde59','#fda31a'][j%3]});}}
function drawFood(g){for(var i=0;i<g.food.length;i++){var fd=g.food[i];var im=IMG[fd.key];var yy=fd.y+Math.sin(fd.bob)*4;
  if(imgOK(im)){var H=fd.h,W=H*im.naturalWidth/im.naturalHeight;ctx.drawImage(im,fd.x-W/2,yy-H/2,W,H);}
  else{ctx.fillStyle='#ffde59';ctx.beginPath();ctx.arc(fd.x,yy,16,0,6.3);ctx.fill();}}}

// ---------- HARDER spawning ----------
function spawn(g){
  var airOK=g.score>D.airThresh,isBird=airOK&&Math.random()<0.36;
  if(isBird){var ys=[GROUND_Y-98,GROUND_Y-56];g.obs.push({type:'bird',x:LW+40,y:ys[Math.random()<.5?0:1],w:46,h:30,frame:Math.random()*6});
  }else{var pk=OBSTACLES[(Math.random()*OBSTACLES.length)|0];var im=IMG[pk.key];
    var ar=imgOK(im)?im.naturalWidth/im.naturalHeight:1;var h=pk.h,w=h*ar;
    g.obs.push({type:'obj',key:pk.key,x:LW+40,y:GROUND_Y+22,w:w,h:h});}
  var base=Math.max(30,82-(g.speed-380)/7);g.spawnIn=(base+Math.random()*base*0.9)*D.spawnMul;
}
function die(g){g.state=STATE.DEAD;g.m.deadT=0;for(var i=0;i<10;i++)g.parts.push({x:g.m.x+30,y:g.m.y-24,vx:(Math.random()-.5)*260,vy:-Math.random()*260,life:.6,r:2+Math.random()*3,c:'#ff9eb5'});beep(140,.35,'sawtooth',.05);}

function update(g,dt){
  // particles always
  for(var p=0;p<g.parts.length;p++){var pt=g.parts[p];pt.x-=g.speed*dt*(pt.grip?1:.4);pt.x+=pt.vx*dt;pt.y+=pt.vy*dt;pt.vy+=900*dt;pt.life-=dt;}
  g.parts=g.parts.filter(function(x){return x.life>0;});
  if(g.state===STATE.DEAD){g.m.deadT+=dt;g.m.rot=Math.min(Math.PI/2,g.m.rot+dt*7);return;}
  g.dist+=g.speed*dt;g.speed=Math.min(D.speedMax,D.speed0+g.dist*D.accel);g.score=Math.floor(g.dist/24);
  var ci=clamp((g.startIdx||0)+Math.floor(g.dist/24/150),0,ROUTE.length-1);
  if(ci!==g.communeIdx){g.bgPrev=ROUTE[g.communeIdx].bg;g.bgFade=0;g.communeIdx=ci;g.signName=ROUTE[ci].name;g.sign={x:LW+140,done:false};g.toastText=ROUTE[ci].name+' — '+ROUTE[ci].tip;g.toastT=3;beep(700,.08,'sine',.03);}
  if(g.toastT>0)g.toastT-=dt;
  if(g.bgFade<1)g.bgFade=Math.min(1,g.bgFade+dt*1.4);
  g.night=(Math.sin(g.dist*0.0015)+1)/2;
  var m=g.m;var wasAir=!m.onGround;m.vy+=G*dt;m.y+=m.vy*dt;
  if(m.y>=GROUND_Y){m.y=GROUND_Y;m.vy=0;}m.onGround=(m.y>=GROUND_Y-0.5);
  if(wasAir&&m.onGround){for(var d=0;d<6;d++)g.parts.push({x:m.x+20,y:GROUND_Y+8,vx:-40-Math.random()*60,vy:-Math.random()*90,life:.4,r:2+Math.random()*2,c:'#caa06f',grip:1});}
  if(m.onGround&&!m.ducking){m.runFrame+=g.speed*dt*0.09;m.anim=(m.anim||0)+dt*Math.min(15,7+g.speed*0.014);g.dustT-=dt;if(g.dustT<=0){g.dustT=.08;g.parts.push({x:m.x+8,y:GROUND_Y+6,vx:-30,vy:-20-Math.random()*20,life:.35,r:1.5+Math.random()*1.5,c:'#b98f5e',grip:1});}}
  g.spawnIn-=g.speed*dt/6;if(g.spawnIn<=0)spawn(g);
  for(var i=0;i<g.obs.length;i++){var o=g.obs[i];o.x-=g.speed*dt;if(o.type==='bird')o.frame+=dt*11;}
  if(g.sign&&!g.sign.done){g.sign.x-=g.speed*dt*0.66;if(g.sign.x<-220)g.sign.done=true;}
  g.obs=g.obs.filter(function(o){return o.x>-90;});
  // ambient drift
  for(var c=0;c<clouds.length;c++){clouds[c].x-=clouds[c].sp*dt;if(clouds[c].x<-120){clouds[c].x=LW+80;clouds[c].y=30+Math.random()*70;}}
  var mh=m.ducking?30:m.h,my=m.y-mh;var mb={x:m.x+10,y:my+6,w:m.w-22,h:mh-8};
  // gourmandises : apparition, défilement, collecte
  g.foodIn-=g.speed*dt/6;if(g.foodIn<=0){spawnFood(g);g.foodIn=(110+Math.random()*130)/D.foodMul;}
  for(var fi=0;fi<g.food.length;fi++){var fd=g.food[fi];fd.x-=g.speed*dt;fd.bob+=dt*4;
    var fr={x:fd.x-fd.w/2+6,y:fd.y-fd.h/2+6,w:fd.w-12,h:fd.h-12};
    if(!fd.got&&mb.x<fr.x+fr.w&&mb.x+mb.w>fr.x&&mb.y<fr.y+fr.h&&mb.y+mb.h>fr.y){fd.got=true;collectFood(g,fd);}}
  g.food=g.food.filter(function(f){return f.x>-60&&!f.got;});
  for(var j=0;j<g.obs.length;j++){var ob=g.obs[j],r;
    if(ob.type==='bird')r={x:ob.x+6,y:ob.y-4,w:ob.w-12,h:ob.h-6};
    else if(ob.type==='obj')r={x:ob.x-ob.w/2+7,y:ob.y-ob.h+5,w:ob.w-14,h:ob.h-7};
    else r={x:ob.x+4,y:ob.y-ob.h+4,w:ob.w-8,h:ob.h-6};
    if(mb.x<r.x+r.w&&mb.x+mb.w>r.x&&mb.y<r.y+r.h&&mb.y+mb.h>r.y){die(g);return;}}
}

// ---------- richer background ----------
function drawMountains(g,n){
  var off=g.dist*0.06;
  // far range (Pelée-like)
  ctx.fillStyle=mix('#c88a6a','#241a3a',n);
  ctx.beginPath();ctx.moveTo(0,GROUND_Y+52);
  var peaks=[[120,150],[300,120],[470,140],[640,110],[820,150]];
  ctx.lineTo(0,180);
  for(var i=0;i<peaks.length;i++){var px=(peaks[i][0]-off*0.5)%(LW+200);if(px<-100)px+=LW+200;ctx.lineTo(px,peaks[i][1]);}
  ctx.lineTo(LW,180);ctx.lineTo(LW,GROUND_Y+52);ctx.closePath();ctx.fill();
  // near range
  ctx.fillStyle=mix('#9c6a4e','#1c1530',n);
  ctx.beginPath();ctx.moveTo(0,GROUND_Y+52);ctx.lineTo(0,210);
  for(var x=-100;x<=LW+100;x+=90){var h=200-40*Math.abs(Math.sin((x+off)*0.008));ctx.lineTo(x-off%90,h);}
  ctx.lineTo(LW,210);ctx.lineTo(LW,GROUND_Y+52);ctx.closePath();ctx.fill();
}
function drawCloud(cl,n){ctx.save();ctx.globalAlpha=lerp(.85,.3,n);ctx.fillStyle=mix('#fff4e6','#5a5170',n);
  ctx.translate(cl.x,cl.y);ctx.scale(cl.s,cl.s);
  ctx.beginPath();ctx.arc(0,0,16,0,6.3);ctx.arc(18,4,20,0,6.3);ctx.arc(40,2,15,0,6.3);ctx.arc(20,-8,15,0,6.3);ctx.fill();
  ctx.restore();}
function drawPalm(x,scale,color){ctx.save();ctx.translate(x,GROUND_Y+52);ctx.scale(scale,scale);ctx.fillStyle=color;
  ctx.fillRect(-4,-90,8,90);
  for(var a=0;a<6;a++){var ang=-Math.PI/2+(a-2.5)*0.45;ctx.save();ctx.translate(0,-90);ctx.rotate(ang);
    ctx.beginPath();ctx.moveTo(0,0);ctx.quadraticCurveTo(40,-6,66,10);ctx.quadraticCurveTo(40,4,0,4);ctx.fill();ctx.restore();}
  ctx.restore();}
function drawField(g,spd,color,base,amp){ctx.fillStyle=color;var off=(g.dist*spd)%120;
  ctx.beginPath();ctx.moveTo(0,GROUND_Y+52);
  for(var x=-120;x<=LW+120;x+=30){var h=base-amp*Math.abs(Math.sin((x+off)*0.02));ctx.lineTo(x-off,h);}
  ctx.lineTo(LW+120,GROUND_Y+52);ctx.closePath();ctx.fill();}
function rr(x,y,w,h,r){if(ctx.roundRect){ctx.beginPath();ctx.roundRect(x,y,w,h,r);}else{ctx.beginPath();ctx.rect(x,y,w,h);}}
function drawYumBillboards(g,n){var sp=1050,par=0.66,off=g.dist*par,k0=Math.floor(off/sp)-1;
  for(var k=k0;k<=k0+2;k++){var x=k*sp-off;if(x<-260||x>LW+260)continue;
    var bw=200,bh=112,baseY=GROUND_Y-24,panelY=baseY-bh-60; // grand panneau pub (16/9) surélevé sur poteaux
    ctx.save();ctx.globalAlpha=0.94;
    ctx.fillStyle=mix('#786450','#2a2016',n*.5); // poteaux
    ctx.fillRect(x-bw/2+26,panelY+bh,11,baseY-(panelY+bh));ctx.fillRect(x+bw/2-37,panelY+bh,11,baseY-(panelY+bh));
    ctx.fillStyle=mix('#efe9dc','#39352e',n*.5);rr(x-bw/2-5,panelY-5,bw+10,bh+10,10);ctx.fill(); // cadre
    ctx.fillStyle=mix('#ff2e18','#7a1f14',n*.4);rr(x-bw/2,panelY,bw,bh,7);ctx.fill();            // panneau rouge YUM
    if(adBillboardReady){ // vraie image pub : remplit le panneau (cover), coins arrondis + voile de nuit
      ctx.save();rr(x-bw/2,panelY,bw,bh,7);ctx.clip();
      var im=adBillboard,ir=im.naturalWidth/im.naturalHeight,fr=bw/bh,dw,dh;
      if(ir>fr){dh=bh;dw=bh*ir;}else{dw=bw;dh=bw/ir;}
      ctx.drawImage(im,x-dw/2,panelY+(bh-dh)/2,dw,dh);
      if(n>0.02){ctx.fillStyle='rgba(18,14,40,'+(n*0.5)+')';ctx.fillRect(x-bw/2,panelY,bw,bh);}
      ctx.restore();
    }else if(logoReady){var lw=bw-26,lh=lw*logoImg.height/logoImg.width;if(lh>bh-14){lh=bh-14;lw=lh*logoImg.width/logoImg.height;}ctx.drawImage(logoImg,x-lw/2,panelY+(bh-lh)/2,lw,lh);}
    ctx.restore();
  }}
function drawGroundShelf(g,n){var y0=GROUND_Y+20; // chemin constant, quel que soit le décor → contact des pattes garanti
  var gd=ctx.createLinearGradient(0,y0,0,LH);
  gd.addColorStop(0,mix('#946a3c','#241812',n*.7));gd.addColorStop(1,mix('#5a3d22','#120b07',n*.8));
  ctx.fillStyle=gd;ctx.fillRect(0,y0,LW,LH-y0);
  ctx.fillStyle=mix('rgba(220,186,138,.6)','rgba(120,100,70,.4)',n*.6);ctx.fillRect(0,y0,LW,3); // surface du chemin
  ctx.fillStyle=mix('rgba(60,40,25,.5)','rgba(20,14,8,.6)',n);
  for(var k=0;k<16;k++){var gx=((k*97-g.dist)%LW+LW)%LW;ctx.fillRect(gx,y0+9+(k%3)*7,10,3);} // cailloux (repère de vitesse)
}
function drawScene(img,scroll,C){
  if(!imgOK(img)){ // secours : dégradé ciel + sol tant que l'image charge
    var sky=ctx.createLinearGradient(0,0,0,LH);sky.addColorStop(0,C.sky[0]);sky.addColorStop(.6,C.sky[1]);sky.addColorStop(1,C.sky[2]);
    ctx.fillStyle=sky;ctx.fillRect(0,0,LW,LH);
    ctx.fillStyle=C.ground||'#c9b48f';ctx.fillRect(0,GROUND_Y-40,LW,LH-(GROUND_Y-40));return;}
  var iw=img.naturalWidth,ih=img.naturalHeight,dw=LW,dh=dw*ih/iw,dy=(GROUND_Y+22)-dh*0.88; // chemin peint (~88% de l'image) aligné sous les pattes
  var base=Math.floor(scroll/dw);
  for(var t=0;t<=2;t++){var idx=base+t,x=idx*dw-scroll;
    ctx.save();
    if((((idx%2)+2)%2)===1){ctx.translate(x+dw,0);ctx.scale(-1,1);ctx.drawImage(img,0,dy,dw,dh);} // tuile miroir → couture invisible
    else{ctx.drawImage(img,x,dy,dw,dh);}
    ctx.restore();}
}
function drawBg(g){
  var n=g.night;var C=ROUTE[g.communeIdx||0]||ROUTE[0];var scroll=g.dist*BG_PAR;
  // fond ciel : couvre la zone au-dessus du décor quand l'écran est plus haut que l'image (mobile plein écran)
  var sk=ctx.createLinearGradient(0,0,0,GROUND_Y);sk.addColorStop(0,C.sky[0]);sk.addColorStop(1,C.sky[2]);ctx.fillStyle=sk;ctx.fillRect(0,0,LW,LH);
  if(g.bgPrev&&g.bgFade<1){drawScene(IMG[g.bgPrev],scroll,C);ctx.save();ctx.globalAlpha=g.bgFade;drawScene(IMG[C.bg],scroll,C);ctx.restore();}
  else drawScene(IMG[C.bg],scroll,C);
  drawYumBillboards(g,n); // vrais panneaux pub, en arrière-plan (avant le voile de nuit)
  drawGroundShelf(g,n);   // chemin constant au premier plan
  if(n>0.02){ctx.fillStyle='rgba(18,14,40,'+(n*0.5)+')';ctx.fillRect(0,0,LW,LH);} // tombée de la nuit
  if(n>.5){ctx.fillStyle='rgba(255,255,255,'+((n-.5)*1.2)+')';for(var i=0;i<26;i++){var sx=(i*137+g.dist*0.03)%LW,sy=(i*53)%110;ctx.fillRect(sx,sy,2,2);}}
  if(n>.45){for(var f=0;f<flies.length;f++){var fl=flies[f];var a=(Math.sin(g.dist*0.02*fl.sp+fl.ph)+1)/2;
    ctx.fillStyle='rgba(255,214,120,'+(a*(n-.45)*1.6)+')';var fx=((fl.x-g.dist*0.1)%LW+LW)%LW;
    ctx.beginPath();ctx.arc(fx,fl.y+Math.sin(g.dist*0.01+fl.ph)*8,2.2,0,6.3);ctx.fill();}}
}
function shadow(x,y,w,alpha){ctx.save();ctx.fillStyle='rgba(0,0,0,'+(alpha||.22)+')';ctx.beginPath();ctx.ellipse(x,GROUND_Y+24,w,5,0,0,6.3);ctx.fill();ctx.restore();}
function drawParts(g){for(var i=0;i<g.parts.length;i++){var p=g.parts[i];ctx.globalAlpha=clamp(p.life*2,0,1);ctx.fillStyle=p.c;ctx.beginPath();ctx.arc(p.x,p.y,p.r,0,6.3);ctx.fill();}ctx.globalAlpha=1;}
function drawObjObstacle(o,n){var im=IMG[o.key];shadow(o.x,0,o.w*0.42,.28);
  if(imgOK(im)){ctx.save();ctx.shadowColor='rgba(0,0,0,.55)';ctx.shadowBlur=11;ctx.shadowOffsetY=3;ctx.drawImage(im,o.x-o.w/2,o.y-o.h,o.w,o.h);ctx.restore();}
  else{ctx.fillStyle=mix('#8a5a2e','#3a2414',n*.4);ctx.fillRect(o.x-o.w/2,o.y-o.h,o.w,o.h);}}
function drawCane(o,n){shadow(o.x+o.bundles*4,0,o.bundles*10+8);ctx.save();ctx.translate(o.x,o.y);
  ctx.shadowColor='rgba(0,0,0,.65)';ctx.shadowBlur=12;ctx.shadowOffsetY=3; // halo sombre → l'obstacle ressort sur tous les décors
  ctx.save();ctx.strokeStyle='rgba(255,255,255,.85)';ctx.lineWidth=4;for(var w=0;w<o.bundles;w++){var wx=w*15-(o.bundles-1)*7;ctx.strokeRect(wx-7,-o.h-1,14,o.h+2);}ctx.restore(); // liseré blanc
  for(var b=0;b<o.bundles;b++){var bx=b*15-(o.bundles-1)*7;
    var gc=ctx.createLinearGradient(bx-6,0,bx+6,0);gc.addColorStop(0,mix('#b6a24a','#5f5426',n*.6));gc.addColorStop(.5,mix('#d8c766','#8a7a38',n*.6));gc.addColorStop(1,mix('#a08e3c','#4a3f18',n*.6));
    ctx.fillStyle=gc;ctx.fillRect(bx-6,-o.h,12,o.h);
    ctx.strokeStyle=mix('#8f7d2e','#4a3f18',n*.6);ctx.lineWidth=2;
    for(var s=1;s<4;s++){var yy=-o.h*s/4;ctx.beginPath();ctx.moveTo(bx-6,yy);ctx.lineTo(bx+6,yy);ctx.stroke();}
    ctx.fillStyle=mix('#4f8a3a','#1f3a20',n*.6);
    ctx.beginPath();ctx.moveTo(bx,-o.h);ctx.quadraticCurveTo(bx-22,-o.h-14,bx-30,-o.h+2);ctx.quadraticCurveTo(bx-14,-o.h-4,bx,-o.h);ctx.fill();
    ctx.beginPath();ctx.moveTo(bx,-o.h);ctx.quadraticCurveTo(bx+22,-o.h-16,bx+30,-o.h);ctx.quadraticCurveTo(bx+14,-o.h-4,bx,-o.h);ctx.fill();
  }ctx.restore();}
function drawBird(o,n){ctx.save();ctx.translate(o.x+o.w/2,o.y);ctx.shadowColor='rgba(0,0,0,.6)';ctx.shadowBlur=10;var flap=Math.sin(o.frame*2)*0.6;
  ctx.fillStyle=mix('#5a6470','#3a4048',n*.5);ctx.beginPath();ctx.ellipse(0,0,18,11,0,0,6.3);ctx.fill();
  ctx.fillStyle='#ffd23f';ctx.beginPath();ctx.ellipse(2,4,12,7,0,0,6.3);ctx.fill();
  ctx.fillStyle=mix('#454e58','#2c313a',n*.5);ctx.beginPath();ctx.moveTo(-2,-2);ctx.quadraticCurveTo(-24,-2-14*flap,-30,4-8*flap);ctx.quadraticCurveTo(-14,4,-2,2);ctx.fill();
  ctx.fillStyle=mix('#4a525c','#2c313a',n*.5);ctx.beginPath();ctx.arc(15,-4,7,0,6.3);ctx.fill();
  ctx.fillStyle='#2a2f36';ctx.beginPath();ctx.moveTo(21,-5);ctx.lineTo(30,-3);ctx.lineTo(21,-1);ctx.fill();
  ctx.fillStyle='#fff';ctx.beginPath();ctx.arc(16,-6,2,0,6.3);ctx.fill();ctx.fillStyle='#111';ctx.beginPath();ctx.arc(16.6,-6,1,0,6.3);ctx.fill();
  ctx.restore();}
var _runN=null;function runCount(){if(_runN===null){_runN=0;while(IMG['manicou_run'+_runN])_runN++;}return _runN||1;}
function manicouFrame(g){var m=g.m;
  if(g.state===STATE.DEAD)return IMG.manicou_run2||IMG.manicou_run0||IMG.manicou;
  if(m.ducking)return IMG.manicou_run0||IMG.manicou;
  if(!m.onGround)return IMG.manicou_run1||IMG.manicou;      // jambes ramassées au saut
  var N=runCount();var i=Math.floor(m.anim||0)%N;var im=IMG['manicou_run'+i];return imgOK(im)?im:IMG.manicou;}
function drawManicou(g){var m=g.m,n=g.night;var img=manicouFrame(g),ok=imgOK(img);
  if(g.state!==STATE.DEAD)shadow(m.x+m.w/2,0,clamp(28-(GROUND_Y-m.y)*0.12,10,28),clamp(.24-(GROUND_Y-m.y)*0.0008,.06,.24));
  var duck=m.ducking&&g.state!==STATE.DEAD;
  var H=duck?54:84,W=ok?H*img.naturalWidth/img.naturalHeight:H*1.35;
  var cx=m.x+m.w/2,feet=m.y+22;var ph=(m.anim||0)*1.5708; // pattes posées sur le chemin
  ctx.save();ctx.translate(cx,feet);ctx.scale(-1,1); // sprite vidéo tourné à gauche → on le retourne pour courir vers la droite
  if(g.state===STATE.DEAD)ctx.rotate(-m.rot);                      // il fait le mort
  else if(!m.onGround)ctx.rotate(0.14);                            // penché au saut
  else ctx.rotate(Math.sin(ph)*0.035);                             // balancement doux synchronisé
  var bob=(m.onGround&&!duck)?-Math.abs(Math.sin(ph))*1.2:0;       // rebond léger (pattes restent au sol)
  if(ok)ctx.drawImage(img,-W/2,-H+bob,W,H);
  else{ctx.fillStyle=mix('#8f8071','#585044',n*.35);ctx.beginPath();ctx.ellipse(0,-H/2,W/2,H/2,0,0,6.3);ctx.fill();}
  ctx.restore();
}
function vignette(){var v=ctx.createRadialGradient(LW/2,LH/2,LH*0.3,LW/2,LH/2,LH*0.9);
  v.addColorStop(0,'rgba(0,0,0,0)');v.addColorStop(1,'rgba(0,0,0,.32)');ctx.fillStyle=v;ctx.fillRect(0,0,LW,LH);}
function drawCupIcon(x,y,n){ctx.save();ctx.translate(x,y);
  ctx.fillStyle=mix('#fff4e6','#cfc6dd',n*.3);ctx.beginPath();ctx.moveTo(-6,-9);ctx.lineTo(6,-9);ctx.lineTo(4,4);ctx.lineTo(-4,4);ctx.closePath();ctx.fill();
  ctx.strokeStyle=mix('#fda31a','#5a4a80',n*.4);ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(-7,-9);ctx.lineTo(7,-9);ctx.stroke();
  ctx.strokeStyle=mix('#ff2e18','#7a3050',n*.4);ctx.beginPath();ctx.moveTo(1,-9);ctx.lineTo(4,-15);ctx.stroke();
  ctx.fillStyle=mix('#3a2b2b','#1a1420',n*.4);ctx.beginPath();ctx.arc(-2,2,1.4,0,6.3);ctx.arc(2,1,1.4,0,6.3);ctx.arc(0,3,1.4,0,6.3);ctx.fill();ctx.restore();}
function drawYumKiosk(x,n){ctx.save();ctx.translate(x,GROUND_Y+52);
  ctx.fillStyle=mix('#b8834e','#3a2e22',n);ctx.fillRect(-40,-48,80,48);
  ctx.fillStyle=mix('#e6d8b4','#2e2942',n);ctx.fillRect(-44,-16,88,8);
  ctx.fillStyle=mix('#ff2e18','#3a2440',n*.5);ctx.fillRect(-46,-58,92,10);
  for(var i=0;i<7;i++){var ax=-46+i*13.4;ctx.fillStyle=(i%2)?mix('#fff4e6','#2a2440',n*.5):mix('#ff2e18','#3a2440',n*.5);ctx.beginPath();ctx.moveTo(ax,-48);ctx.lineTo(ax+13.4,-48);ctx.lineTo(ax+6.7,-38);ctx.closePath();ctx.fill();}
  ctx.fillStyle=mix('#8a7a5a','#2e2942',n);ctx.fillRect(-2,-96,4,38);
  var bw=108,bh=44,by=-140;
  ctx.fillStyle=mix('#ff2e18','#5a1810',n*.4);if(ctx.roundRect){ctx.beginPath();ctx.roundRect(-bw/2,by,bw,bh,7);ctx.fill();ctx.strokeStyle=mix('#ffffff','#b8b2c0',n*.3);ctx.lineWidth=2;ctx.stroke();}else ctx.fillRect(-bw/2,by,bw,bh);
  if(logoReady){var lw=bw-16,lh=lw*logoImg.height/logoImg.width;if(lh>bh-8){lh=bh-8;lw=lh*logoImg.width/logoImg.height;}ctx.drawImage(logoImg,-lw/2,by+(bh-lh)/2,lw,lh);}
  else{ctx.fillStyle='#fff';ctx.font='bold 20px Trebuchet MS,sans-serif';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText('Y\u00fcM',0,by+bh/2);}
  drawCupIcon(0,-26,n);ctx.restore();}
function drawYumDecor(g,n){var sp=820,par=0.5,off=g.dist*par,k0=Math.floor(off/sp)-1;
  for(var k=k0;k<k0+Math.ceil(LW/sp)+3;k++){var x=k*sp-off+120;if(x>-90&&x<LW+90)drawYumKiosk(x,n);}
  var bsp=1650,bo=g.dist*0.5,b0=Math.floor(bo/bsp)-1;
  for(var b=b0;b<b0+2;b++){var bx=b*bsp-bo+620;if(bx>-140&&bx<LW+140)drawYumBillboard(bx,n);}}
function drawYumBillboard(x,n){var base=GROUND_Y+52;ctx.save();ctx.translate(x,base);
  ctx.fillStyle=mix('#7a6a4a','#2a2418',n);ctx.fillRect(-4,-72,8,72);ctx.fillRect(-42,-72,84,6);
  var bw=150,bh=70,by=-148;
  ctx.fillStyle=mix('#ff2e18','#5a1810',n*.4);if(ctx.roundRect){ctx.beginPath();ctx.roundRect(-bw/2,by,bw,bh,8);ctx.fill();ctx.strokeStyle=mix('#ffffff','#b8b2c0',n*.3);ctx.lineWidth=3;ctx.stroke();}else ctx.fillRect(-bw/2,by,bw,bh);
  if(logoReady){var lw=bw-20,lh=lw*logoImg.height/logoImg.width;if(lh>bh-10){lh=bh-10;lw=lh*logoImg.width/logoImg.height;}ctx.drawImage(logoImg,-lw/2,by+(bh-lh)/2,lw,lh);}
  ctx.restore();}
function drawYumBalloons(g,n){var sp=520,off=g.dist*0.22,k0=Math.floor(off/sp)-1,cols=['#ff2e18','#ffde59','#fda31a'];
  for(var k=k0;k<k0+Math.ceil(LW/sp)+2;k++){var x=k*sp-off+80;if(x<-40||x>LW+40)continue;
    var y=42+(((k*53)%56)+56)%56+Math.sin(g.dist*0.006+k)*6,col=cols[((k%3)+3)%3];
    ctx.strokeStyle=mix('#c9bfae','#5a5468',n);ctx.lineWidth=1;ctx.beginPath();ctx.moveTo(x,y+14);ctx.lineTo(x,y+30);ctx.stroke();
    ctx.fillStyle=mix(col,'#2a2440',n*.5);ctx.beginPath();ctx.arc(x,y,14,0,6.3);ctx.fill();
    ctx.fillStyle=mix('#1a1016','#0a0812',n*.3);ctx.beginPath();ctx.arc(x-5,y-3,2,0,6.3);ctx.arc(x+5,y-3,2,0,6.3);ctx.fill();
    ctx.strokeStyle=mix('#1a1016','#0a0812',n*.3);ctx.lineWidth=2;ctx.beginPath();ctx.arc(x,y+2,7,0.12*Math.PI,0.88*Math.PI);ctx.stroke();}}
function drawBunting(g,n){ctx.save();var off=(g.dist*0.5)%44,cols=['#ff2e18','#ffde59','#fda31a'];ctx.globalAlpha=lerp(.85,.5,n);
  ctx.strokeStyle=mix('#e8ddc8','#6a6080',n);ctx.lineWidth=1.5;
  for(var x=-44;x<LW+44;x+=44){var bx=x-off;ctx.beginPath();ctx.moveTo(bx,10);ctx.quadraticCurveTo(bx+22,20,bx+44,10);ctx.stroke();
    var idx=(((Math.round(bx/44))%3)+3)%3;ctx.fillStyle=mix(cols[idx],'#3a3450',n*.4);
    ctx.beginPath();ctx.moveTo(bx+16,13);ctx.lineTo(bx+28,13);ctx.lineTo(bx+22,26);ctx.closePath();ctx.fill();}ctx.restore();}
function drawLandFdF(g,n){var base=GROUND_Y+52;
  var po=g.dist*0.12;ctx.fillStyle=mix('#4e7a52','#1a2a32',n);
  var pk=[[LW*0.30,150],[LW*0.44,168]];
  for(var q=0;q<pk.length;q++){var px=pk[q][0]-po*0.4;ctx.beginPath();ctx.moveTo(px-72,base);ctx.lineTo(px,pk[q][1]);ctx.lineTo(px+72,base);ctx.closePath();ctx.fill();}
  var par=0.35,off=g.dist*par,sp=72,start=Math.floor(off/sp)-1;
  for(var k=start;k<start+16;k++){var x=k*sp-off;if(x>LW+40||x<-80)continue;
    var h=54+(((k*37)%54)+54)%54,isCath=(((k%6)+6)%6)===2;
    ctx.fillStyle=mix('#e4ddce','#2a2440',n*.9);ctx.fillRect(x,base-h,58,h);
    if(isCath){ctx.fillStyle=mix('#b06a48','#3a2a44',n);ctx.fillRect(x+24,base-h-34,10,34);ctx.beginPath();ctx.moveTo(x+22,base-h-34);ctx.lineTo(x+29,base-h-52);ctx.lineTo(x+36,base-h-34);ctx.fill();}
    ctx.fillStyle=mix('#9aa2b2','#4a4260',n*.6);for(var wy=base-h+10;wy<base-10;wy+=15)for(var wx=x+8;wx<x+50;wx+=14)ctx.fillRect(wx,wy,6,8);}
  var fo=g.dist*0.42,fsp=1500,f0=Math.floor(fo/fsp)-1;
  for(var f=f0;f<f0+2;f++){var fx=f*fsp-fo+300;if(fx<-60||fx>LW+60)continue;
    ctx.fillStyle=mix('#c9b48f','#2e2440',n);ctx.fillRect(fx-34,base-40,68,40);
    for(var cc=0;cc<5;cc++)ctx.fillRect(fx-34+cc*15,base-48,9,10);
    ctx.strokeStyle=mix('#8a5a3a','#3a2a20',n);ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(fx,base-48);ctx.lineTo(fx,base-66);ctx.stroke();
    ctx.fillStyle=mix('#ff2e18','#7a2018',n);ctx.beginPath();ctx.moveTo(fx,base-66);ctx.lineTo(fx+14,base-62);ctx.lineTo(fx,base-58);ctx.fill();}}
function drawLandLamentin(g,n){var base=GROUND_Y+52;
  ctx.strokeStyle=mix('#5aa6c8','#243848',n);ctx.lineWidth=10;ctx.lineCap='round';
  var ro=g.dist*0.28;ctx.beginPath();for(var x=-40;x<=LW+40;x+=40){var y=base-30+18*Math.sin((x+ro)*0.02);if(x===-40)ctx.moveTo(x,y);else ctx.lineTo(x,y);}ctx.stroke();
  var bsp=140,bo=g.dist*0.5,b0=Math.floor(bo/bsp)-1;
  for(var b=b0;b<b0+Math.ceil(LW/bsp)+2;b++){var bx=b*bsp-bo;if(bx<-30||bx>LW+30)continue;
    ctx.strokeStyle=mix('#3c7a3a','#16301a',n);ctx.lineWidth=3;
    for(var a=0;a<5;a++){var ang=-Math.PI/2+(a-2)*0.5;ctx.save();ctx.translate(bx,base-18);ctx.rotate(ang);ctx.beginPath();ctx.moveTo(0,0);ctx.quadraticCurveTo(16,-4,26,4);ctx.stroke();ctx.restore();}}
  var px=LW-((g.dist*0.6)%(LW+520)),py=54+16*Math.sin(g.dist*0.002);
  ctx.save();ctx.translate(px,py);ctx.fillStyle=mix('#eef2f7','#8a90a0',n);
  ctx.beginPath();ctx.ellipse(0,0,26,7,0,0,6.3);ctx.fill();
  ctx.beginPath();ctx.moveTo(-6,0);ctx.lineTo(4,-12);ctx.lineTo(12,-12);ctx.lineTo(6,0);ctx.fill();
  ctx.beginPath();ctx.moveTo(2,2);ctx.lineTo(-10,15);ctx.lineTo(8,3);ctx.fill();ctx.restore();
  var tsp=1500,to=g.dist*0.4,t0=Math.floor(to/tsp)-1;
  for(var t=t0;t<t0+2;t++){var tx=t*tsp-to+500;if(tx<-40||tx>LW+40)continue;
    ctx.fillStyle=mix('#dfe4ea','#33303f',n);ctx.fillRect(tx-6,base-70,12,70);
    ctx.fillStyle=mix('#7fb3d6','#2a3a48',n);ctx.fillRect(tx-14,base-80,28,14);}}
function drawLandDucos(g,n){var base=GROUND_Y+52,par=0.4,off=g.dist*par,sp=150,k0=Math.floor(off/sp)-1;
  ctx.fillStyle=mix('#6aa596','#22403c',n);ctx.fillRect(0,base-16,LW,16);
  for(var k=k0;k<k0+Math.ceil(LW/sp)+2;k++){var x=k*sp-off;if(x<-60||x>LW+60)continue;
    ctx.fillStyle=mix('#2f6b3f','#123222',n);ctx.beginPath();ctx.arc(x,base-58,26,0,6.3);ctx.arc(x+18,base-50,20,0,6.3);ctx.arc(x-16,base-50,18,0,6.3);ctx.fill();
    ctx.strokeStyle=mix('#5a3d28','#241a12',n);ctx.lineWidth=3;
    for(var r=-2;r<=2;r++){ctx.beginPath();ctx.moveTo(x+r*6,base-40);ctx.lineTo(x+r*12,base-2);ctx.stroke();}}
  var kx=LW-((g.dist*0.45)%(LW+420)),ky=base-8;
  ctx.save();ctx.translate(kx,ky);ctx.fillStyle=mix('#ffde59','#6a5510',n);
  ctx.beginPath();ctx.ellipse(0,0,20,5,0,0,6.3);ctx.fill();
  ctx.fillStyle=mix('#ff2e18','#5a1810',n);ctx.beginPath();ctx.arc(0,-8,5,0,6.3);ctx.fill();
  ctx.strokeStyle=mix('#7a5a3a','#2a2018',n);ctx.lineWidth=2;ctx.beginPath();ctx.moveTo(-10,-14);ctx.lineTo(10,-2);ctx.stroke();ctx.restore();}
function drawLandSaintEsprit(g,n){var base=GROUND_Y+52;
  var mo=g.dist*0.16;ctx.fillStyle=mix('#5c9450','#1a2e1e',n);
  ctx.beginPath();ctx.moveTo(0,base);for(var x=-100;x<=LW+100;x+=60){var h=150-46*Math.abs(Math.sin((x+mo)*0.006));ctx.lineTo(x-mo%60,h);}ctx.lineTo(LW,base);ctx.closePath();ctx.fill();
  var mo2=g.dist*0.24;ctx.fillStyle=mix('#4a8040','#152618',n);
  ctx.beginPath();ctx.moveTo(0,base);for(var x2=-100;x2<=LW+100;x2+=70){var h2=180-40*Math.abs(Math.sin((x2+mo2)*0.007));ctx.lineTo(x2-mo2%70,h2);}ctx.lineTo(LW,base);ctx.closePath();ctx.fill();
  var wsp=1300,wo=g.dist*0.24,w0=Math.floor(wo/wsp)-1;
  for(var w=w0;w<w0+2;w++){var wx=w*wsp-wo+260;if(wx<-30||wx>LW+30)continue;
    ctx.fillStyle=mix('rgba(232,246,255,.85)','rgba(150,180,200,.5)',n);ctx.fillRect(wx-4,152,8,base-162);
    ctx.beginPath();ctx.arc(wx,base-8,10,0,6.3);ctx.fill();}
  ctx.strokeStyle=mix('#5aa6c8','#243848',n);ctx.lineWidth=8;ctx.lineCap='round';
  var ro=g.dist*0.3;ctx.beginPath();for(var rx=-40;rx<=LW+40;rx+=40){var ry=base-8+8*Math.sin((rx+ro)*0.03);if(rx===-40)ctx.moveTo(rx,ry);else ctx.lineTo(rx,ry);}ctx.stroke();
  var par=0.38,off=g.dist*par,sp=130,k0=Math.floor(off/sp)-1,pastels=['#f2c9a0','#f0d9a0','#c9d9c0','#e8c0c0'];
  for(var k=k0;k<k0+Math.ceil(LW/sp)+2;k++){var x=k*sp-off;if(x<-60||x>LW+60)continue;
    var h=44+(((k*29)%20)+20)%20,isChurch=(((k%5)+5)%5)===2;
    if(isChurch){ctx.fillStyle=mix('#e6ddc8','#2f2940',n);ctx.fillRect(x,base-66,40,66);
      ctx.fillStyle=mix('#b08a5a','#3a2a44',n);ctx.fillRect(x+14,base-90,12,24);
      ctx.fillStyle=mix('#7bb0ac','#2f3a48',n);ctx.beginPath();ctx.arc(x+20,base-90,9,Math.PI,0);ctx.fill();
    }else{ctx.fillStyle=mix(pastels[((k%4)+4)%4],'#2a2440',n*.85);ctx.fillRect(x,base-h,46,h);
      ctx.fillStyle=mix('#b5473e','#3a2030',n);ctx.beginPath();ctx.moveTo(x-2,base-h);ctx.lineTo(x+23,base-h-14);ctx.lineTo(x+48,base-h);ctx.fill();}}}
function drawLandFrancois(g,n){var base=GROUND_Y+52;
  var sea=ctx.createLinearGradient(0,base-50,0,base);sea.addColorStop(0,mix('#7fdfe0','#2a4a58',n));sea.addColorStop(1,mix('#bff2ea','#345a5a',n));
  ctx.fillStyle=sea;ctx.fillRect(0,base-50,LW,50);
  ctx.fillStyle=mix('rgba(255,255,255,.5)','rgba(200,220,220,.25)',n);for(var s=0;s<6;s++){var sx=((s*180-g.dist*0.2)%LW+LW)%LW;ctx.fillRect(sx,base-22,80,6);}
  var hsp=1400,ho=g.dist*0.32,h0=Math.floor(ho/hsp)-1;
  for(var hh=h0;hh<h0+2;hh++){var hx=hh*hsp-ho+320;if(hx<-60||hx>LW+60)continue;
    ctx.fillStyle=mix('#f0e6d2','#2e2942',n);ctx.fillRect(hx-30,base-58,60,26);
    ctx.fillStyle=mix('#b5473e','#3a2030',n);ctx.beginPath();ctx.moveTo(hx-36,base-58);ctx.lineTo(hx,base-78);ctx.lineTo(hx+36,base-58);ctx.fill();
    ctx.fillStyle=mix('#a86a44','#3a2a20',n);ctx.fillRect(hx+40,base-70,10,38);ctx.fillRect(hx+38,base-74,14,6);}
  var sp=260,off=g.dist*0.3,k0=Math.floor(off/sp)-1;
  for(var k=k0;k<k0+Math.ceil(LW/sp)+2;k++){var x=k*sp-off;if(x<-60||x>LW+60)continue;
    ctx.fillStyle=mix('#e9dfc0','#3a3a40',n);ctx.beginPath();ctx.ellipse(x,base-42,34,8,0,0,6.3);ctx.fill();
    ctx.fillStyle=mix('#3c8a4a','#153a20',n);ctx.beginPath();ctx.arc(x,base-50,14,Math.PI,0);ctx.fill();
    ctx.fillStyle=mix('#2f6b3a','#123018',n);ctx.fillRect(x-3,base-60,6,10);}
  var yx=LW-((g.dist*0.5)%(LW+400)),yy=base-32;
  ctx.save();ctx.translate(yx,yy);ctx.fillStyle=mix('#e8a13a','#5a3a18',n);
  ctx.beginPath();ctx.moveTo(-18,0);ctx.quadraticCurveTo(0,10,18,0);ctx.lineTo(12,-2);ctx.lineTo(-12,-2);ctx.fill();
  ctx.fillStyle=mix('#fff4e6','#9a9088',n);ctx.beginPath();ctx.moveTo(0,-2);ctx.lineTo(0,-30);ctx.lineTo(16,-4);ctx.fill();
  ctx.strokeStyle=mix('#6a5030','#2a2018',n);ctx.lineWidth=1.5;ctx.beginPath();ctx.moveTo(0,-2);ctx.lineTo(0,-32);ctx.stroke();ctx.restore();}
function drawSign(g){if(!g.sign||g.sign.done)return;var x=g.sign.x,n=g.night,name=g.signName||opts.commune||DEFAULT_COMMUNE;
  ctx.save();ctx.globalAlpha=0.9;ctx.translate(x,GROUND_Y-34);ctx.scale(0.72,0.72); // surélevé + réduit = arrière-plan (ne se confond plus avec un obstacle)
  ctx.fillStyle=mix('#8f8f99','#3a3a48',n);ctx.fillRect(-3,-64,6,64);
  ctx.font='bold 15px Trebuchet MS,sans-serif';var tw=ctx.measureText(name).width,bw=Math.max(96,tw+30),bh=30,by=-64-bh+4;
  ctx.fillStyle='#d9342b';ctx.fillRect(-bw/2-4,by-4,bw+8,bh+8);
  ctx.fillStyle=mix('#ffffff','#d6d2e0',n*.3);ctx.fillRect(-bw/2,by,bw,bh);
  ctx.fillStyle='#1a1a1a';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(name,0,by+bh/2);ctx.restore();}
function drawToast(g){if(!g.toastT||g.toastT<=0)return;var a=clamp(g.toastT,0,1);ctx.save();ctx.globalAlpha=a;
  ctx.font='bold 15px Trebuchet MS,sans-serif';var t=g.toastText||'',w=ctx.measureText(t).width+30,x=LW/2-w/2,y=16;
  ctx.fillStyle='rgba(20,12,38,.74)';if(ctx.roundRect){ctx.beginPath();ctx.roundRect(x,y,w,26,13);ctx.fill();}else ctx.fillRect(x,y,w,26);
  ctx.fillStyle='#ffedae';ctx.textAlign='center';ctx.textBaseline='middle';ctx.fillText(t,LW/2,y+13);ctx.restore();}
function render(g){ctx.setTransform(1,0,0,1,0,0);ctx.clearRect(0,0,cv.width,cv.height);
  var portrait=cv.height>cv.width;
  var s,ox,oy;
  if(portrait){
    // Portrait : on ZOOME (au lieu du simple fit) pour agrandir manicou + décor. Le manicou (x=120)
    // reste ancré à ~14% de la largeur (bon aperçu devant), et le sol à ~60% de la hauteur.
    s=(cv.width/LW)*1.5;
    ox=cv.width*0.14-120*s;
    oy=cv.height*0.60-GROUND_Y*s;
  }else{
    // Paysage/desktop : remplit l'écran (cover), ancré en bas → rogne le ciel, jamais le sol.
    s=Math.max(cv.width/LW,cv.height/LH);
    ox=(cv.width-LW*s)/2;oy=cv.height-LH*s;
  }
  ctx.save();ctx.translate(ox,oy);ctx.scale(s,s);ctx.beginPath();ctx.rect(0,0,LW,LH);ctx.clip();
  drawBg(g);drawBunting(g,g.night);drawSign(g);
  for(var i=0;i<g.obs.length;i++){var o=g.obs[i];if(o.type==='obj')drawObjObstacle(o,g.night);else if(o.type==='cane')drawCane(o,g.night);else drawBird(o,g.night);}
  drawFood(g);drawParts(g);drawManicou(g);vignette();drawToast(g);ctx.restore();}
function drawStatic(){if(!clouds.length)initAmbient();
  var g={dist:0,night:0,obs:[],parts:[],food:[],communeIdx:0,bgPrev:null,bgFade:1,state:STATE.START,m:{x:120,y:GROUND_Y,w:64,h:52,runFrame:1.2,onGround:true,ducking:false,vy:0,rot:0,deadT:0}};render(g);}

  // ================= Boucle & contrôle (adapté du HTML source) =================
  var game=null,raf=null,last=0,startTime=0;
  function now(){return (typeof performance!=='undefined'&&performance.now)?performance.now():Date.now();}

  function loop(t){if(!last)last=t;var dt=(t-last)/1000;last=t;if(dt>0.05)dt=0.05;
    update(game,dt);render(game);
    if(opts.onScore)opts.onScore({score:game.score,collected:game.collected||0,cupN:game.cupN||0,cupGoal:CUP_GOAL});
    // Seuil de score atteint → fin de partie GAGNANTE (le serveur valide et délivre le bon)
    if(opts.goalScore&&game.state===STATE.RUN&&(game.score||0)>=opts.goalScore){finish();return;}
    if(game.state===STATE.DEAD&&game.m.deadT>0.7){finish();return;}
    raf=requestAnimationFrame(loop);}

  function finish(){if(raf)cancelAnimationFrame(raf);raf=null;
    var duration=Math.max(0.1,(now()-startTime)/1000);
    var impressions=[];
    if(adSlot&&adBillboardReady){impressions.push({
      campaign_id:adSlot.campaign.id,placement_id:adSlot.placement.id,
      seconds_visible:Math.round(duration),clicked:false});}
    if(opts.onDie)opts.onDie({score:game.score,collected:game.collected||0,
      duration_s:duration,impressions:impressions});}

  function jump(){if(!game||game.state!==STATE.RUN)return;var m=game.m;if(m.onGround){m.vy=JUMP_V;m.onGround=false;beep(520,.08,'square',.03);}}
  function duckStart(){if(!game||game.state!==STATE.RUN)return;game.m.ducking=true;if(!game.m.onGround)game.m.vy+=300;}
  function duckEnd(){if(game)game.m.ducking=false;}

  // Contrôles : clavier (desktop) uniquement. Le manicou se contrôle SEULEMENT via les
  // boutons à l'écran (jump/duckStart/duckEnd exposés) — plus de saut/accroupi en tapant la carte.
  function onKeyDown(e){if(e.code==='Space'||e.code==='ArrowUp'){e.preventDefault();jump();}if(e.code==='ArrowDown'){e.preventDefault();duckStart();}}
  function onKeyUp(e){if(e.code==='ArrowDown')duckEnd();}
  function onResize(){resize();}
  // Rotation d'écran : les dimensions du canvas ne sont fiables qu'après stabilisation du layout,
  // donc on re-dimensionne en différé. Le ResizeObserver couvre tous les cas (résolution robuste).
  function onOrient(){setTimeout(resize,200);setTimeout(resize,500);}
  var ro=null;
  try{ro=new ResizeObserver(function(){resize();});ro.observe(cv);}catch(e){}

  window.addEventListener('keydown',onKeyDown);
  window.addEventListener('keyup',onKeyUp);
  window.addEventListener('resize',onResize);
  window.addEventListener('orientationchange',onOrient);

  try{resize();initAmbient();}catch(e){}
  game=newGame();last=0;startTime=now();
  raf=requestAnimationFrame(loop);

  return {
    stop:function(){
      if(raf)cancelAnimationFrame(raf);raf=null;game=null;
      window.removeEventListener('keydown',onKeyDown);
      window.removeEventListener('keyup',onKeyUp);
      window.removeEventListener('resize',onResize);
      window.removeEventListener('orientationchange',onOrient);
      if(ro){try{ro.disconnect();}catch(e){}ro=null;}
    },
    toggleMute:function(){muted=!muted;return muted;},
    // Actions exposées pour les boutons tactiles à l'écran
    jump:jump,
    duckStart:duckStart,
    duckEnd:duckEnd
  };
}
